import { useQuery } from '@tanstack/react-query'
import { ListChecks } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { onboarding as api } from '@/api/endpoints'
import { useAuth } from '@/store/auth'

import { setOnboardingHidden, useOnboardingHidden } from './visibility'

/**
 * Ikonka v hlavičke, ktorá vráti skrytú kartu „Ako začať“. Je len vtedy, keď
 * je karta skrytá a zostáva niečo nedokončené - inak by nemala čo ukázať.
 */
export function OnboardingButton({ className }: { className?: string }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isAdmin = Boolean(useAuth((s) => s.user)?.can_administrate)
  const hidden = useOnboardingHidden()
  const { data } = useQuery({
    queryKey: ['onboarding'],
    queryFn: api.get,
    enabled: isAdmin && hidden,
    staleTime: 60 * 1000,
  })

  if (!isAdmin || !hidden || !data || !data.show || data.done >= data.total) return null

  const label = `${t('onboarding.title')} (${data.done}/${data.total})`
  return (
    <button
      type="button"
      onClick={() => {
        setOnboardingHidden(false)
        navigate('/calendar')
      }}
      className={className}
      title={label}
      aria-label={label}
    >
      <ListChecks size={18} />
    </button>
  )
}
